import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';

import Form from 'components/ui/Form';
import { selectedProperties, modes } from '../NoticeHelpers';
import MultiSelect from '../../../NoticeMultiselect';

const FullWidthSelect = styled(MultiSelect)`
  width: 100%;
`;

const RisersInput = ({ values, errors, touched, setFieldValue, properties, units }) => {
  const { mode } = values;

  const riserOptions = useMemo(() => {
    if (units.length === 0) return [];

    const unitsForRisers = units;
    let risersHash = {};
    unitsForRisers.forEach((unit) => {
      if (unit['riser_name'] in risersHash) {
        risersHash[unit['riser_name']] += 1;
      } else if (unit['riser_name']) {
        risersHash[unit['riser_name']] = 1;
      }
    });
    return Object.keys(risersHash).map((key) => ({
      value: key,
      label: `${key} - ${risersHash[key]} ${getTranslatedString(
        'landlordPortal.noticeAssignmentForm.unitsLowcase'
      )}`,
      number_of_units: risersHash[key],
    }));
  }, [units]);

  const handleChange = (risers) => {
    let setRisers = risers || [];
    setRisers = Array.isArray(setRisers) ? setRisers : [setRisers];

    setFieldValue('risers', setRisers);
  };

  // Can only show the risers selection on a single selected property
  if (values.properties.length === 0 || values.properties.length > 1) {
    return null;
  }
  // Only need risers selection for its mode.
  if (mode !== modes.SELECTING_ROWS) return null;

  if (selectedProperties(values, properties).is_single_unit) return null;

  return (
    <Form.Item label={getTranslatedString('landlordPortal.noticeAssignmentForm.rowsPlural')}>
      <FullWidthSelect
        options={riserOptions}
        name="risers"
        fullWidth
        withResetSelectAllButtons
        multiple
        value={values.risers}
        error={touched.risers && errors.risers}
        onChange={handleChange}
      />
    </Form.Item>
  );
};

export default connect((store) => {
  return {
    properties: store.landlordProperties.properties,
    units: store.landlordProperties.units,
  };
}, {})(RisersInput);
